// Libs
import { pipe } from 'fp-ts/lib/function';
import { join } from 'lodash/fp';

// Types
import { Answers } from './types';

export const buildSurveyOption = (answers: Answers[]): string =>
  pipe(answers, join(','), line => `{${line}}`);
